export const assessmentSpanish = {
  steps: {
    basics: {
      title: "Información básica",
      intro: "Un poco de contexto ayuda a adaptar tus orientaciones generales de nutrición."
    },
    "fruit-vegetables": {
      title: "Consumo de fruta y verdura",
      intro: "La fruta y la verdura aportan fibra, vitaminas, minerales y compuestos vegetales protectores."
    },
    "fibre-wholegrains": {
      title: "Fibra, cereales integrales e hidratos",
      intro: "Los cereales integrales, las legumbres, los frutos secos, las semillas y una porción equilibrada de hidratos pueden ayudarte a tomar más fibra y mantener la energía."
    },
    protein: {
      title: "Hábitos relacionados con las proteínas",
      intro: "Consumir alimentos ricos en proteínas con regularidad favorece la saciedad, el mantenimiento muscular y unas comidas equilibradas."
    },
    calcium: {
      title: "Hábitos de calcio",
      intro: "Los lácteos y las alternativas vegetales enriquecidas pueden contribuir a la ingesta de calcio."
    },
    hydration: {
      title: "Hidratación",
      intro: "La cantidad de líquido que tomas forma parte de tus hábitos nutricionales diarios."
    },
    "meal-patterns": {
      title: "Rutina de comidas",
      intro: "Mantener comidas regulares facilita cubrir las necesidades nutricionales a lo largo del día."
    },
    lifestyle: {
      title: "Estilo de vida",
      intro: "El movimiento, el sueño y las rutinas diarias pueden influir en los hábitos alimentarios y la energía."
    }
  },
  questions: {
    ageRange: { label: "¿Cuál es tu intervalo de edad?" },
    gender: { label: "Género", helper: "Opcional" },
    mainGoal: { label: "¿Cuál es tu principal objetivo nutricional?" },
    fruitPortions: { label: "¿Cuántas raciones de fruta tomas en un día habitual?" },
    vegetablePortions: { label: "¿Cuántas raciones de verdura o ensalada tomas en un día habitual?" },
    wholegrains: { label: "¿Con qué frecuencia tomas pan integral, avena, arroz integral o pasta integral?" },
    legumes: { label: "¿Con qué frecuencia tomas alubias, lentejas, garbanzos u otras legumbres?" },
    nutsSeeds: { label: "¿Con qué frecuencia incluyes frutos secos y semillas en tus comidas?" },
    carbohydratePlate: { label: "En las comidas, ¿qué parte del plato ocupan alimentos ricos en hidratos como pasta, arroz, pan, patata, boniato, quinoa o cuscús?" },
    proteinFrequency: { label: "¿Con qué frecuencia consumes alimentos ricos en proteínas como pescado, huevos, lácteos, tofu, legumbres, aves o carne magra?" },
    calciumServings: { label: "¿Cuántas raciones de lácteos o alternativas vegetales enriquecidas tomas al día?" },
    fluidIntake: { label: "¿Cuánto líquido bebes al día?" },
    breakfast: { label: "¿Desayunas habitualmente?" },
    mealsPerDay: { label: "De media, ¿cuántas comidas haces al día?" },
    regularTimes: { label: "¿Sueles comer a horas regulares?" },
    activityDays: { label: "¿Cuántos días a la semana realizas actividad física?" },
    stepsAverage: { label: "¿Cuántos pasos haces de media al día?" },
    sleepQuality: { label: "¿Cómo valorarías la calidad de tu sueño?" }
  },
  options: {
    gender: {
      female: "Mujer",
      male: "Hombre",
      "non-binary": "No binario",
      "prefer-not": "Prefiero no decirlo"
    },
    mainGoal: {
      "hormone-health": "Apoyar la salud hormonal (SOP, endometriosis, perimenopausia y menopausia)",
      "improve-overall-health": "Mejorar la salud general",
      "weight-management": "Controlar el peso",
      "sports-performance": "Mejorar el rendimiento deportivo",
      "chronic-condition": "Gestionar una condición crónica (diabetes, colesterol, osteoporosis, etc.)",
      "digestive-gut-health": "Salud digestiva e intestinal y manejo de síntomas"
    },
    fruitPortions: {
      none: "Ninguna",
      one: "1 ración",
      two: "2 raciones",
      "three-plus": "3 o más raciones"
    },
    vegetablePortions: {
      none: "Ninguna",
      one: "1 ración",
      two: "2 raciones",
      "three-plus": "3 o más raciones"
    },
    wholegrains: {
      rarely: "Casi nunca o nunca",
      weekly: "1-2 veces por semana",
      "most-days": "La mayoría de los días",
      daily: "A diario, pero no en todas las comidas",
      "daily-most-meals": "A diario, en todas mis comidas"
    },
    legumes: {
      rarely: "Casi nunca o nunca",
      monthly: "1-2 veces al mes",
      weekly: "1-2 veces por semana",
      often: "3 o más veces por semana"
    },
    nutsSeeds: {
      never: "Nunca",
      rarely: "Casi nunca",
      sometimes: "A veces",
      "most-of-the-time": "La mayoría de las veces"
    },
    carbohydratePlate: {
      none: "No incluyo hidratos en la mayoría de mis comidas",
      "quarter-third": "Un cuarto o un tercio del plato",
      "half-most": "La mitad del plato"
    },
    proteinFrequency: {
      low: "Menos de una vez al día",
      once: "Una vez al día",
      twice: "Dos veces al día",
      "all-meals": "En todas las comidas"
    },
    calciumServings: {
      zero: "Nunca",
      one: "Casi nunca",
      two: "A veces",
      three: "La mayoría de las veces"
    },
    fluidIntake: {
      "under-one": "Menos de 1 litro",
      "one-to-one-half": "1-1,5 litros",
      "one-half-to-two": "1,5-2 litros",
      "over-two": "Más de 2 litros"
    },
    breakfast: {
      rarely: "Casi nunca",
      "few-days": "Algunos días por semana",
      "most-days": "La mayoría de los días",
      daily: "A diario"
    },
    mealsPerDay: {
      one: "1 comida",
      two: "2 comidas",
      three: "3 comidas"
    },
    regularTimes: {
      rarely: "Casi nunca",
      sometimes: "A veces",
      often: "A menudo",
      always: "Casi siempre"
    },
    activityDays: {
      zero: "0 días",
      "one-two": "1-2 días",
      "three-four": "3-4 días",
      "five-plus": "5 o más días"
    },
    stepsAverage: {
      "under-5000": "Menos de 5.000",
      "5000-8000": "Entre 5.000 y 8.000",
      "8000-10000": "8.000-10.000",
      "10000-plus": "10.000 o más"
    },
    sleepQuality: {
      poor: "Mala",
      fair: "Regular",
      good: "Buena",
      "very-good": "Muy buena"
    }
  },
  results: {
    scoreLabels: {
      overall: "Puntuación nutricional general",
      fibre: "Hábitos de fibra",
      carbohydrates: "Equilibrio de hidratos",
      protein: "Hábitos de proteínas",
      fruitVegetables: "Consumo de fruta y verdura",
      calcium: "Hábitos de calcio",
      hydration: "Hábitos de hidratación",
      lifestyle: "Hábitos de estilo de vida",
      mealPatterns: "Regularidad de las comidas"
    },
    ratings: {
      strong: "Sólido",
      developing: "Evoluciona bien",
      improve: "Puede mejorar",
      attention: "Necesita atención"
    },
    summaries: {
      fibreHigh: "Tus hábitos de fibra parecen positivos. Seguir incluyendo cereales integrales, legumbres, fruta y verdura puede favorecer una alimentación equilibrada.",
      fibreLow: "Tu consumo de fibra parece inferior a lo ideal. Aumentar los cereales integrales, las legumbres, la fruta y la verdura puede favorecer la salud digestiva.",
      proteinHigh: "Tus hábitos de proteínas parecen sólidos y probablemente favorecen la saciedad y el mantenimiento muscular.",
      proteinLow: "Tu consumo de proteínas podría ser más constante. Añadir una fuente de proteínas a más comidas puede hacerlas más equilibradas.",
      fruitVegetablesHigh: "Tu consumo de fruta y verdura parece favorecer una buena calidad global de la dieta.",
      fruitVegetablesLow: "Podrías aumentar el consumo de fruta y verdura. Incorporar pequeñas cantidades a lo largo del día puede facilitar que mantengas este hábito.",
      hydrationHigh: "Tus hábitos de hidratación parecen adecuados. Tener agua disponible durante el día puede ayudarte a mantener esta rutina.",
      hydrationLow: "Podrías mejorar la hidratación aumentando el consumo diario de líquidos y eligiendo bebidas sin azúcar con más frecuencia.",
      lifestyleHigh: "Tus hábitos de actividad y sueño parecen favorecer tu bienestar general.",
      lifestyleLow: "Tu estilo de vida podría beneficiarse de un movimiento más regular y de prestar atención a la calidad del sueño.",
      mealPatternsHigh: "Tu rutina de comidas parece estable, lo que facilita mantener una alimentación equilibrada.",
      mealPatternsLow: "Tu rutina de comidas podría ser más regular. Planificar comidas o tentempiés sencillos puede ayudar a reducir las comidas que te saltas.",
      overallHigh: "Tus respuestas indican un patrón alimentario generalmente favorable, con varios hábitos útiles ya consolidados.",
      overallLow: "Tus respuestas indican que existen varias oportunidades realistas para reforzar tus hábitos nutricionales diarios."
    },
    positive: {
      fibre: "Bien hecho. Tus hábitos de fibra parecen sólidos y pueden apoyar la digestión, la saciedad y el bienestar general.",
      carbohydrates: "Tu equilibrio de hidratos parece favorable. Una porción adecuada, especialmente con opciones integrales o ricas en fibra, puede apoyar la energía diaria.",
      protein: "Bien hecho. Tus hábitos de proteína parecen sólidos y pueden apoyar la saciedad, el mantenimiento muscular y la recuperación.",
      fruitVegetables: "Bien hecho. Tu consumo de fruta y verdura parece apoyar una buena calidad global de la dieta.",
      calcium: "Tus hábitos de calcio parecen favorables. Los lácteos o alternativas vegetales enriquecidas pueden contribuir a la ingesta de calcio.",
      hydration: "Bien hecho. Tus hábitos de hidratación parecen apoyar la energía, la concentración y la digestión.",
      lifestyle: "Bien hecho. Tus hábitos de movimiento y sueño parecen apoyar tu bienestar general.",
      mealPatterns: "Tu rutina de comidas parece estable y puede facilitar una alimentación equilibrada."
    },
    improvement: {
      fibre: "Tu ingesta de fibra podría aumentar. Incluir verduras, fruta, cereales integrales, legumbres, frutos secos y semillas puede apoyar la digestión y la saciedad.",
      carbohydrates: "Tu patrón de hidratos podría equilibrarse mejor. Muy poca cantidad puede afectar la energía, mientras que porciones muy grandes pueden desplazar proteína y verduras.",
      protein: "Tu ingesta de proteína podría ser más constante. Incluir alimentos ricos en proteína durante el día puede apoyar el apetito y comidas equilibradas.",
      fruitVegetables: "Tu consumo de fruta y verdura podría aumentar. Pequeñas incorporaciones durante el día pueden mejorar fibra y micronutrientes.",
      calcium: "Tu ingesta de calcio podría reforzarse. Los lácteos o alternativas vegetales enriquecidas pueden ayudar si se incluyen de forma constante.",
      hydration: "Tu hidratación podría mejorar aumentando la ingesta diaria de líquidos.",
      lifestyle: "Tus hábitos de estilo de vida podrían beneficiarse de más movimiento regular y mayor atención al descanso.",
      mealPatterns: "Tu rutina de comidas podría ser más regular para apoyar mejor tu nutrición diaria."
    },
    recommendations: {
      fruitVegetables: "Añade una ración extra de verdura en la comida o la cena.",
      fibre: "Elige opciones integrales y añade más legumbres, frutos secos, semillas, verduras y fruta.",
      carbohydrates: "Busca que los hidratos ocupen aproximadamente un cuarto o un tercio del plato, priorizando opciones integrales o ricas en fibra.",
      protein: "Incluye una fuente de proteínas en el desayuno o en la comida menos equilibrada del día.",
      calcium: "Considera añadir una ración de lácteos o una alternativa vegetal enriquecida.",
      hydration: "Lleva una botella de agua reutilizable para beber líquidos con regularidad.",
      lifestyle: "Planifica sesiones breves y realistas de actividad durante la semana y mantén una rutina de descanso constante cuando sea posible.",
      mealPatterns: "Ten disponible una comida o un tentempié sencillo para los días con más actividad.",
      general: "Sigue creando comidas basadas en verduras, alimentos ricos en proteínas, cereales integrales y líquidos con regularidad."
    }
  }
};

export function localizeAssessmentSteps(steps, language) {
  if (!language?.startsWith("es")) return steps;

  return steps.map((step) => ({
    ...step,
    ...assessmentSpanish.steps[step.id],
    questions: step.questions.map((question) => ({
      ...question,
      ...assessmentSpanish.questions[question.id],
      options: question.options.map((option) => ({
        ...option,
        label: assessmentSpanish.options[question.id]?.[option.value] || option.label
      }))
    }))
  }));
}
